/* build 2026-09-08T12h — creneaux exposes dans SA_BOOKING */
/* SublimAuto - moteur de reservation.
   Lit la config et les reservations dans les metafields de boutique,
   calcule la capacite en heures-personne par jour, collecte les coordonnees,
   et envoie la reservation au postier.

   Regle de survie : si la config est absente ou invalide, le script sort
   immediatement et les boutons Reserver gardent leur comportement d'origine.
   Le site ne casse jamais a cause du booking.

   ==========================================================================
   2026-08-04 — POURQUOI ON NE PASSE PLUS PAR /contact
   Shopify protege ses formulaires avec hCaptcha, et depuis juillet 2024 il
   REJETTE en erreur 400 toute soumission sans jeton valide. Le jeton n'est
   pose que sur les formulaires presents dans la page au chargement : un
   formulaire fabrique en JavaScript et envoye dans la seconde n'en a jamais.

   Consequence : 100 % des reservations echouaient. Pas parfois — toujours.
   Et les deux fonctions censees nous prevenir passaient elles aussi par
   /contact, donc les alertes echouaient aussi. Panne totalement muette.

   Maintenant la reservation part directement au postier (Apps Script), qui
   ecrit le metaobjet, regenere le cache, pose l'agenda et confirme au client.
   Shopify n'est plus sur le chemin d'une vente.
   ========================================================================== */
(function () {
  "use strict";

  /* L'adresse du postier. Publique par nature — c'est du JavaScript de page.
     Elle n'ouvre rien : le postier ne fait qu'ECRIRE des rendez-vous, il ne
     rend aucune donnee, et il refuse ce qui n'a pas la forme d'un rendez-vous.
     Le jeton Shopify, lui, reste chez Google et ne sort jamais. */
  var POSTIER = "https://script.google.com/macros/s/AKfycbyM6g7_MrizqvfBFrCwknqVmL5XhBfjgN87p6gmZ0dppjmUR022xR8ZCdUx-h3zM79E/exec";

  var CLE_FILE = "sublimauto_rdv_en_attente";   /* file de secours, localStorage */
  var CLE_FILE_ALERTES = "sublimauto_alertes_en_attente";   /* GESTE C : meme principe, pour les alertes */
  var ESSAIS_MAX = 3;                            /* 1 essai + 2 reprises */

  /* ================= Fondations ================= */

  function lireJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      var v = JSON.parse(el.textContent);
      return (typeof v === "string") ? JSON.parse(v) : v;
    } catch (e) { return null; }
  }

  var cfg = lireJSON("v2-bk-config");
  var res = lireJSON("v2-bk-reservations") || { rdv: [] };
  var voile = document.getElementById("bkVoile");

  if (!cfg || !cfg.durees || !cfg.variantes) {
    if (window.console) console.warn("[booking] config absente - CTA d'origine conserves");
    return;
  }
  /* 2026-09-03 — SANS PANNEAU, LE MOTEUR VIT QUAND MEME. La page concession
     (/pages/concessionnaire) charge ce fichier sans rendre `v2-booking` : elle
     n'a pas besoin du panneau, elle a besoin du CALCUL — capacite du jour,
     heures prises, fermetures. Plutot qu'une deuxieme copie du moteur dans
     `v2-concession.js` (trois copies ont deja derive une fois, voir le noeud
     `app-reservations-regle-architecture-seul`), on expose les primitives
     dans `window.SA_BOOKING` juste avant les evenements, puis on s'arrete la
     si le panneau est absent. Rien ne change pour les pages qui ont le panneau. */
  var sansPanneau = !voile;
  if (!Array.isArray(res.rdv)) res.rdv = [];

  var JOURS = ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"];
  var MOIS = ["janvier", "février", "mars", "avril", "mai", "juin",
              "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
  var TIERS = { bronze: "Bronze", argent: "Argent", or: "Or" };
  var ZONES = { both: "Intérieur + Extérieur", int: "Intérieur", ext: "Extérieur" };
  var TEL = "418 808-6352";
  var TEL_LIEN = "4188086352";

  /* ⚠️ PIEGE — NE JAMAIS envoyer `etat.vehNom` (le LIBELLE affiche au client,
     ex. "camionnette / 7 places", "VUS") a un champ que le postier ou l'app
     stocke/relit. Cote reception, AppHome.jsx:161 n'a que trois cles exactes :
     VEH_VERS_CODE = { berline, vus, camionnette } (minuscules, sans accent,
     sans texte descriptif). Une valeur qui ne matche pas une de ces trois cles
     retombe silencieusement sur '0' = BERLINE (AppHome.jsx:351), donc un
     abonnement ou un rendez-vous camionnette est traite - et facture au futur
     comme s'il etait berline. `CODE_VERS_VEH` ci-dessous est la copie fidele
     de AppHome.jsx:162 : c'est CA qu'on envoie, jamais le libelle. */
  var CODE_VERS_VEH = { "0": "berline", "25": "vus", "50": "camionnette" };

  var R = cfg.regles || {};
  var etat = {
    tier: null, zone: "both", veh: "0", vehNom: "berline",
    date: null, heure: null, envoi: false
  };
  var moisAffiche = new Date();
  var dernierFocus = null;

  var el = {};
  ["bkGrille", "bkHeures", "bkBlocHeures", "bkConfirmer", "bkNote", "bkRecap",
   "bkMois", "bkPrec", "bkSuiv", "bkSousTitre", "bkFermer", "bkPanneau", "bkAlerte",
   "bkPrenom", "bkNom", "bkTel", "bkCourriel", "bkAdresse",
   "bkErrPrenom", "bkErrNom", "bkErrTel", "bkErrCourriel", "bkErrAdresse",
   "bkCoordonnees"].forEach(function (id) {
    el[id] = document.getElementById(id);
  });

  /* ================= Utilitaires ================= */

  function minutes(hhmmStr) {
    var p = String(hhmmStr).split(":");
    return (+p[0]) * 60 + (+p[1] || 0);
  }
  function hhmm(min) {
    var h = Math.floor(min / 60), m = min % 60;
    return h + " h" + (m ? " " + (m < 10 ? "0" : "") + m : "");
  }
  function iso(d) {
    return d.getFullYear() + "-" +
      ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
      ("0" + d.getDate()).slice(-2);
  }
  function memeJour(a, b) { return iso(a) === iso(b); }
  function nombre(n) { return (Math.round(n * 10) / 10).toLocaleString("fr-CA"); }
  function echappe(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ================= Capacite ================= */

  /* Heures-personne REELLEMENT productives ce jour-la.
     La presence n'est pas la production : Alex fait de l'administration, il y a
     des pauses, des imprevus, du nettoyage d'atelier. Le facteur de productivite
     evite de vendre des heures que personne ne travaillera. */

  /* ==========================================================================
     v11 — RENDEMENT DECROISSANT (Alex, 2026-08-24)

     Trois personnes sur une auto ne rendent pas trois. Elles se nuisent : on
     se croise, on attend le meme boyau, on se passe la meme piece. Alex mesure
     que trois gars rendent 2,5. Le code, lui, multipliait platement par le
     nombre de tetes — donc a trois il promettait une reprise 45 minutes trop
     tot sur un Int Bronze au pire cas, et vendait 1,8 h-p de trop par jour.

     La courbe vit dans `regles.rendement`, PAS ici : c'est une mesure
     d'atelier, elle bougera. La changer ne doit pas demander un deploiement.
     Forme : {"1":1,"2":2,"3":2.5}. Absente => comportement lineaire d'avant,
     donc une vieille config se comporte exactement comme elle se comportait.

     Au-dela de la derniere cle connue on PROLONGE PAR PALIER au lieu de
     revenir au brut : quatre personnes ne peuvent pas rendre plus que la
     courbe ne le dit a trois. Se tromper vers le bas coute une place vendable ;
     se tromper vers le haut coute une promesse rompue au client.
     ========================================================================== */
  function rendement(n) {
    var t = R && R.rendement;
    if (!t || !(n > 0)) return n;
    if (typeof t[String(n)] === "number") return t[String(n)];
    var pal = null;
    for (var k in t) {
      if (!Object.prototype.hasOwnProperty.call(t, k)) continue;
      var i = +k;
      if (i <= n && typeof t[k] === "number" && (pal === null || i > pal)) pal = i;
    }
    return pal === null ? n : t[String(pal)];
  }

  /* ==========================================================================
     v10 — AJUSTEMENTS DE CALENDRIER
     Le champ `bloque` ne connaissait qu'un etat : ouvert ou ferme. La realite
     d'un atelier en a quatre : partir en vacances (une PLAGE), un employe
     absent (capacite REDUITE, pas nulle), une job qui deborde (fermer une
     DEMI-journee), et ouvrir un dimanche parce que ca adonne (ouverture
     EXCEPTIONNELLE).

     Priorite explicite, INDEPENDANTE de l'ordre du tableau : `ouvre` bat
     `ferme` bat `bloque`. Les facteurs de capacite se CUMULENT. Une config
     sans `ajustements` se comporte exactement comme avant.
     ========================================================================== */
  function ajustementsDu(d) {
    var s = iso(d), out = [];
    (cfg.ajustements || []).forEach(function (a) {
      if (!a || !a.debut) return;
      var fin = a.fin || a.debut;
      /* Une plage a l'envers (fin avant debut) ne couvre rien : on l'ignore
         plutot que de la faire silencieusement disparaitre. */
      if (fin < a.debut) return;
      if (s >= a.debut && s <= fin) out.push(a);
    });
    return out;
  }
  function plageValide(p) {
    return !!(p && p.length === 2 && minutes(p[1]) > minutes(p[0]));
  }
  function ouvertureDu(d) {
    var base = (cfg.ouverture && cfg.ouverture[String(d.getDay())]) || null;
    /* Priorite explicite, INDEPENDANTE de l'ordre du tableau : une ouverture
       exceptionnelle l'emporte sur un simple horaire reduit. Une plage a
       l'envers (18:00-09:00) est ignoree au lieu de vider la journee. */
    var horaire = null, ouvre = null;
    ajustementsDu(d).forEach(function (a) {
      if (a.effet === "horaire" && plageValide(a.plage)) horaire = a.plage;
      if (a.effet === "ouvre"   && plageValide(a.plage)) ouvre   = a.plage;
    });
    return ouvre || horaire || base;
  }
  function estFerme(d) {
    /* Priorite : `ouvre` bat `ferme` bat `bloque`, quel que soit l'ordre dans
       le tableau. L'ancienne version dependait de l'ordre : poser l'ouverture
       avant la fermeture laissait la journee fermee, en contradiction avec ce
       que l'ecran affichait. */
    var ferme = estBloque(d), ouvre = false;
    ajustementsDu(d).forEach(function (a) {
      if (a.effet === "ferme") ferme = true;
      if (a.effet === "ouvre") ouvre = true;
    });
    return ouvre ? false : ferme;
  }
  function facteurJour(d) {
    /* Les reductions se CUMULENT : deux absences a moitie le meme jour laissent
       le quart de la capacite, pas la moitie. L'ancienne version gardait le
       dernier facteur lu et sous-estimait le trou. */
    var f = 1;
    ajustementsDu(d).forEach(function (a) {
      if ((a.effet === "capacite" || a.effet === "ouvre") && typeof a.facteur === "number") f *= a.facteur;
    });
    return f < 0 ? 0 : f;
  }

  function capaciteJour(d) {
    var jour = d.getDay();
    /* v10 : l'horaire effectif peut etre remplace par un ajustement, et une
       journee normalement fermee peut etre ouverte exceptionnellement. */
    if (!ouvertureDu(d)) return 0;
    if (estFerme(d)) return 0;

    var brut = 0;

    /* v10 : une ouverture exceptionnelle apporte sa PROPRE couverture. Sans ca,
       ouvrir un dimanche ne donnerait aucune capacite — personne n'a le
       dimanche dans son horaire, donc la boucle d'equipe rendrait zero. */
    var excep = null;
    ajustementsDu(d).forEach(function (a) { if (a.effet === "ouvre") excep = a; });
    if (excep) {
      var oe = ouvertureDu(d);
      var pers = (typeof excep.personnes === "number") ? excep.personnes
               : (R.personnesParVehicule || 2);
      brut = (minutes(oe[1]) - minutes(oe[0])) / 60 * rendement(pers);
    } else {
      /* v11 : on INTEGRE quart d'heure par quart d'heure au lieu d'additionner
         les presences une par une. La somme par personne ne sait pas combien
         de monde est la EN MEME TEMPS — et c'est exactement ce dont le
         rendement depend. A courbe lineaire les deux donnent le meme chiffre
         au quart d'heure pres : la v10 n'est pas contredite, elle est calculee
         autrement. La fenetre reste l'horaire EFFECTIF du jour, donc les
         ajustements v10 (demi-journee, horaire reduit) continuent de mordre. */
      var ouv = ouvertureDu(d);
      var t0 = minutes(ouv[0]), t1 = minutes(ouv[1]);
      var ajsJour = ajustementsDu(d);
      for (var t = t0; t < t1; t += 15) {
        var n = 0;
        var mt = t;
        (cfg.equipe || []).forEach(function (p) {
          /* v12 (2026-09-08) : une absence datee retire la personne nommee
             pendant sa plage, et son remplacant la remplace au compte. */
          var eff = effetAbsences(ajsJour, p, mt);
          if (eff === "absent") return;
          if (eff === "comble") { n++; return; }
          if (!p.jours || p.jours.indexOf(jour) === -1) return;
          if (p.surDemande) return; // « au besoin » n'est pas vendu
          if (minutes(p.debut) > mt || minutes(p.fin) <= mt) return;
          n++;
        });
        brut += rendement(n) / 4;
      }
    }

    var prod = (R.productivitePourcent != null ? R.productivitePourcent : 100) / 100;
    var sais = (cfg.saison && cfg.saison[String(d.getMonth() + 1)]);
    if (sais == null) sais = 1;
    return brut * prod * sais * facteurJour(d);   /* v10 : capacite reduite ponctuelle */
  }

  function estBloque(d) {
    return !!(cfg.bloque && cfg.bloque.indexOf(iso(d)) !== -1);
  }

  function rdvDuJour(dateISO) {
    return res.rdv.filter(function (r) { return r && r.date === dateISO; });
  }
  function heuresPrises(dateISO) {
    return rdvDuJour(dateISO).reduce(function (s, r) { return s + (+r.hp || 0); }, 0);
  }

  /* ==========================================================================
     GESTE A (2026-08-14) — ON NE MONTRE JAMAIS UNE PLAGE DEJA VENDUE.

     Regle d'Alex, mot pour mot : « faut pas montrer les places qu'on a vendues,
     ces la base ». Elle gouverne tout ce bloc.

     Le metachamp `sublimauto.reservations` a DEUX ECRIVAINS AVEC DEUX SCHEMAS :
     le postier ecrit {version:3, rdv:[{..., duree}]} avec la duree en MINUTES,
     l'app admin ecrit encore {version:2, rdv:[{...}]} SANS duree. Le dernier
     qui ecrit gagne, en silence — ce cache peut redevenir v2 a tout moment,
     meme apres que ce filtre ait ete deploye.

     UNE PREMIERE VERSION DE CE CODE se desactivait quand la duree manquait, en
     laissant le controle serveur rattraper. C'etait le mauvais arbitrage : ca
     preservait exactement le defaut qu'on voulait corriger — le site continuait
     d'afficher comme libres des plages deja vendues, et le client ne l'apprenait
     qu'apres avoir rempli tout le formulaire.

     L'ARBITRAGE RETENU : quand la duree manque, on bloque quand meme, avec le
     MEME repli que le postier (240 min). Les deux erreurs possibles ne coutent
     pas la meme chose — une plage bloquee a tort coute une reservation qu'on
     aurait peut-etre eue ; une plage vendue deux fois coute un client furieux,
     une journee d'atelier perdue, et la confiance. On penche donc toujours du
     cote qui protege le client deja servi.

     Le controle serveur (`chevauchePlage()` cote postier) reste le filet : ce
     filtre-ci evite au client de remplir un formulaire pour rien. */
  var DUREE_DEFAUT_MIN = 240; /* meme valeur que le postier et l'app admin — les trois doivent toujours dire la meme chose */

  function chevauche(debutA, dureeA, debutB, dureeB) {
    return debutA < debutB + dureeB && debutB < debutA + dureeA;
  }

  function rdvChevauchants(dateISO, debutMin, dureeMin) {
    return rdvDuJour(dateISO).some(function (r) {
      if (!r || !r.heure) return false;
      var d = (typeof r.duree === "number" && r.duree > 0) ? r.duree : DUREE_DEFAUT_MIN;
      return chevauche(debutMin, dureeMin, minutes(r.heure), d);
    });
  }

  function heuresRestantes(d) {
    var cap = capaciteJour(d);
    if (!cap) return 0;
    var reserve = cap * (R.reserveCapacitePourcent || 0) / 100;
    return Math.max(0, cap - reserve - heuresPrises(iso(d)));
  }

  /* Le garage a un nombre de places limite, independamment des heures. */
  function placesRestantes(d) {
    var max = R.vehiculesMaxParJour;
    if (!max) return 99;
    return Math.max(0, max - rdvDuJour(iso(d)).length);
  }

  /* ================= Lecture du configurateur ================= */

  function zoneActive() {
    var b = document.querySelector(".switch button.on");
    return (b && b.dataset.svc) || "both";
  }
  function vehActif() {
    var b = document.querySelector(".veh-switch button.on");
    return { code: (b && b.dataset.veh) || "0", nom: (b && b.dataset.vehNom) || "berline" };
  }
  function ajoutsActifs() {
    return [].slice.call(document.querySelectorAll(".ajout-btn.on"))
      .map(function (b) { return b.dataset.ajout; })
      .filter(function (c) { return cfg.ajouts && cfg.ajouts[c]; });
  }

  /* Un ajout deja compris dans le tier n'est ni facture ni compte en temps.
     C'est le correctif du conflit ajouts / inclusions : payer deux fois la meme
     chose est un litige et un mauvais avis en attente. */
  function ajoutsFacturables(tier) {
    var inclus = (cfg.inclusions && cfg.inclusions[tier]) || [];
    return ajoutsActifs().filter(function (c) { return inclus.indexOf(c) === -1; });
  }
  function ajoutsDejaInclus(tier) {
    var inclus = (cfg.inclusions && cfg.inclusions[tier]) || [];
    return ajoutsActifs().filter(function (c) { return inclus.indexOf(c) !== -1; });
  }

  function cleForfait() { return etat.zone + "_" + etat.tier; }

  /* 2026-09-09 — UNE SEULE lecture de l'etiquette de source, partagee par
     l'URL de la page merci, la charge du postier et le signal de creneau.
     En avoir trois copies, c'est garantir qu'un jour la fenetre de 7 jours
     changera a un seul des trois endroits. */
  function sourceVisite() {
    try {
      var b = JSON.parse(localStorage.getItem("sa_src") || "null");
      if (!b || !b.v) return "";
      if (Date.now() - b.t > 7 * 24 * 60 * 60 * 1000) return "";
      return String(b.v).replace(/[^a-z0-9_-]/gi, "").slice(0, 20);
    } catch (e) { return ""; }
  }

  /* 2026-09-09 — SIGNAL D'INTENTION, decide avec Alex le 2026-09-09.
     Le client vient de choisir un creneau COMPLET (jour + heure). C'est le
     dernier geste avant de donner son nom : il a trouve ce qu'il cherchait.

     Pourquoi l'heure et pas le jour : un clic sur un jour sans heure signifie
     tres souvent qu'aucun creneau ne convenait et que la personne repart.
     Optimiser la-dessus apprendrait a Meta a trouver des gens qui consultent
     les disponibilites et abandonnent.

     ⚠️ AUCUNE VALEUR n'est envoyee, volontairement. Un creneau choisi n'est
     pas un revenu ; lui coller un montant, c'est fabriquer de la valeur qui
     n'existe pas — le piege des 1 558 « conversions » de pages vues du compte
     Google. On envoie un COMPTE, pas des dollars.

     Une seule fois par chargement de page : changer d'heure ne recompte pas. */
  /* 2026-09-09 — Le moteur du tunnel vit dans le bloc SA-PARCOURS de
     `layout/theme.liquid`, parce qu'il doit tourner sur TOUTES les pages,
     y compris celles ou ce fichier n'est pas charge. Ici on ne fait que le
     nourrir. S'il est absent, on ne casse rien : on ne mesure simplement pas. */
  function etape(n) {
    try { if (window.SA_PARCOURS && window.SA_PARCOURS.atteindre) window.SA_PARCOURS.atteindre(n); }
    catch (e) {}
  }

  /* 2026-09-16 — LES GESTES, l'autre mesure. Le moteur vit dans le bloc
     SA-GESTES de `layout/theme.liquid`, pour la meme raison que le tunnel : il
     doit tourner sur toutes les pages. Ici on ne fait que le nourrir de ce que
     lui seul ne peut pas savoir — QUEL forfait est en jeu au moment du geste.
     S'il est absent, on ne casse rien : on ne mesure simplement pas. */
  function geste(evt, detail) {
    try { if (window.SA_GESTES && window.SA_GESTES.noter) window.SA_GESTES.noter(evt, detail); }
    catch (e) {}
  }
  var joursEssayes = 0;

  var creneauSignale = false;
  function signalerCreneau() {
    if (creneauSignale) return;
    creneauSignale = true;
    var s = sourceVisite();

    /* Meta. Le navigateur est le bon endroit : a ce moment le client n'a pas
       encore donne son courriel, mais fbq joint _fbp/_fbc tout seul. Un envoi
       serveur n'aurait aucun identifiant et serait rejete. */
    try {
      if (typeof fbq === "function") {
        var d = { content_category: "passage", content_name: cleForfait() };
        if (s) d.sa_src = s;
        fbq("trackCustom", "DateChoisie", d);
      }
    } catch (e) { /* la mesure ne casse jamais une reservation */ }

    /* 2026-09-21 — LE MEME SIGNAL, VERS GOOGLE.
       Meme raison de le faire dans le navigateur : Google lit son propre
       temoin _gcl_aw, qu'il a pose lui-meme au clic publicitaire. On ne
       stocke donc aucun identifiant de clic — la decision du 2026-08-26 tient.
       Si le visiteur est organique, _gcl_aw n'existe pas, l'evenement part
       sans etre rattache : normal et sans dommage.

       ⚠️ UN try SEPARE DE CELUI DE META, VOLONTAIREMENT. Avant, un `return`
       sur `typeof fbq !== "function"` sortait de toute la fonction : Meta
       absent aurait prive Google d'un signal qui ne le regarde pas.

       ⚠️ send_to VISE GA4 EXPLICITEMENT. Sans lui, gtag diffuse a toutes les
       balises configurees, y compris AW-17764094551 — on enverrait un
       evenement dans le compte Ads sans savoir ce qu'il y devient.

       ⚠️ AUCUNE VALEUR, comme cote Meta. Un creneau choisi n'est pas un
       revenu. C'est exactement ce qui avait ete fait de travers en aout avec
       la conversion AW-17764094551/Y-d3CKSHw84bENekypZC, qui comptait chaque
       page vue comme une conversion. On envoie un COMPTE, pas des dollars. */
    try {
      if (typeof gtag === "function") {
        var g = { send_to: "G-32BQ2PD2HT", forfait: cleForfait() };
        if (s) g.sa_src = s;
        gtag("event", "creneau_choisi", g);
      }
    } catch (e) { /* la mesure ne casse jamais une reservation */ }
  }

  function dureeHP() {
    var base = cfg.durees[cleForfait()];
    if (!base) return { min: 0, max: 0 };
    var mult = (cfg.multiplicateurVehicule && cfg.multiplicateurVehicule[etat.veh]) || 1;
    var min = base.min * mult, max = base.max * mult;
    ajoutsFacturables(etat.tier).forEach(function (c) {
      min += cfg.ajouts[c].min || 0;
      max += cfg.ajouts[c].max || 0;
    });
    return { min: min, max: max };
  }

  /* ==========================================================================
     IMMOBILISATION REELLE — combien de temps l'auto reste chez nous.

     2026-08-11. Diviser les heures-personne par deux supposait deux personnes
     du matin au soir. Si un seul gars est la de 9 h a midi, une auto deposee a
     9 h avance deux fois moins vite pendant trois heures : le client a qui on
     promettait 2 h 45 repartait a 13 h 15, et c'etait nous qui avions tort.

     On avance par quarts d'heure en consommant les heures-personne au rythme
     du monde REELLEMENT present. Zero personne : le temps passe, le travail
     n'avance pas.

     ⚠️ COPIE FIDELE de `finDuTravail()` dans l'app d'admin (AppHome.jsx).
     Meme raison que `capaciteJour()` : le calcul doit exister la ou on affiche
     ET la ou on ecrit. LES DEUX DOIVENT DIRE LA MEME CHOSE — toute
     modification de l'une se reporte sur l'autre, sinon le site annonce une
     heure de reprise que l'atelier ne connait pas.
     ========================================================================== */

  function etatDe(p) {
    if (p && p.etat) return p.etat;
    return p && p.surDemande ? "besoin" : "dispo";
  }

  /* ABSENCE PONCTUELLE — l'ajustement `absence` retire UNE personne nommee
     (`qui`, son id) d'une plage d'heures, et peut la faire remplacer par une
     autre (`comblePar`, son id). `plage` absente = toute sa journee.
     ⚠️ COPIE FIDELE de `absenceVise`/`effetAbsences` dans AppHome.jsx, dans
     v2-rdv-client.liquid, dans le postier et dans la receptionniste. */
  function absenceVise(a, m) {
    if (!a || a.effet !== "absence") return false;
    if (!a.plage || a.plage.length !== 2) return true;     /* toute la journee */
    return m >= minutes(a.plage[0]) && m < minutes(a.plage[1]);
  }

  /* Partir l'emporte sur remplacer : les deux sur la meme personne est une
     faute de saisie, et se tromper vers le bas coute une place vendable,
     vers le haut une promesse rompue. */
  function effetAbsences(ajs, p, m) {
    var absent = false, comble = false;
    (ajs || []).forEach(function (a) {
      if (!absenceVise(a, m)) return;
      if (p && p.id && a.qui === p.id) absent = true;
      if (p && p.id && a.comblePar === p.id) comble = true;
    });
    return absent ? "absent" : (comble ? "comble" : null);
  }

  /* Un forfait qui deborde sur le lendemain doit lire les absences DU
     LENDEMAIN, pas celles du jour du depot. */
  function dateDecalee(dateISO, n) {
    var d = new Date(dateISO + "T12:00:00");
    if (n) d.setDate(d.getDate() + n);
    return d;
  }

  /* `minuteDuJour` peut depasser 1440 : un gros forfait deborde sur le
     lendemain, et le lendemain n'a ni le meme horaire ni la meme equipe. */
  /* `dateISO` est FACULTATIF et change tout. Sans lui on repond sur la semaine
     type ; avec lui, les absences datees mordent. Un appelant qui a la date et
     ne la passe pas annonce une heure de reprise que l'atelier ne tiendra pas. */
  function personnesA(jour, minuteDuJour, dateISO) {
    var saut = Math.floor(minuteDuJour / 1440);
    var j = (jour + saut) % 7;
    var m = ((minuteDuJour % 1440) + 1440) % 1440;
    var ouv = (cfg.ouverture && cfg.ouverture[String(j)]) || null;
    if (!ouv) return 0;
    if (m < minutes(ouv[0]) || m >= minutes(ouv[1])) return 0;
    var ajs = dateISO ? ajustementsDu(dateDecalee(dateISO, saut)) : [];
    var n = 0;
    (cfg.equipe || []).forEach(function (p) {
      var eff = effetAbsences(ajs, p, m);
      if (eff === "absent") return;
      /* Le remplacant compte MEME « au besoin » et MEME hors de son horaire
         declare : c'est le sens de combler. */
      if (eff === "comble") { n++; return; }
      if (!p.jours || p.jours.indexOf(j) === -1) return;
      if (etatDe(p) !== "dispo") return;      /* « au besoin » n'est pas vendu */
      if (minutes(p.debut) > m || minutes(p.fin) <= m) return;
      n++;
    });
    return n;
  }

  function finDuTravail(jour, debutMin, hp, dateISO) {
    var PAS = 15;
    var MAX = 60 * 24 * 4;   /* garde-fou : une couverture vide bouclerait */
    var reste = hp, t = debutMin, ecoule = 0;
    while (reste > 0.001 && ecoule < MAX) {
      var pers = rendement(personnesA(jour, t, dateISO));   /* v11 : trois tetes ne rendent pas trois */
      if (pers > 0) reste -= (pers * PAS) / 60;
      t += PAS; ecoule += PAS;
    }
    /* Un depot et une reprise dans la meme demi-heure n'a pas de sens pour le
       client : on ne descend jamais sous 30 minutes annoncees. */
    if (ecoule < 30) { t += 30 - ecoule; ecoule = 30; }
    return { fin: t, heures: ecoule / 60, fini: reste <= 0.001 };
  }

  /* Repli quand l'equipe n'est pas configuree : mieux vaut l'ancienne
     approximation que rien du tout. */
  function dureeCalendaire(hp) {
    return hp / (R.personnesParVehicule || 2);
  }

  /* Le seul point d'entree pour « combien de temps l'auto reste ». Tout le
     reste du fichier passe par ici : une seule regle, un seul endroit. */
  function immobilisation(jour, debutMin, hp, dateISO) {
    if (!(cfg.equipe || []).length) {
      return { fin: debutMin + Math.round(dureeCalendaire(hp) * 60),
               heures: dureeCalendaire(hp), fini: true };
    }
    return finDuTravail(jour, debutMin, hp, dateISO);
  }

  /* ================= Recap ================= */

  function texteAjout(cle) {
    var b = document.querySelector('.ajout-btn[data-ajout="' + cle + '"] .a-nom');
    return b ? b.textContent.trim() : cle;
  }
  function prixAjout(cle) {
    var b = document.querySelector('.ajout-btn[data-ajout="' + cle + '"]');
    return b ? (+b.dataset.prix || 0) : 0;
  }
  function prixAffiche() {
    var p = document.querySelector("#tier-" + etat.tier + ' [data-slot="prix"]');
    return p ? p.textContent.trim() : "";
  }

  function ligne(k, v, cls) {
    return '<div class="bk-ligne' + (cls ? " " + cls : "") + '"><span>' + k + "</span><b>" + v + "</b></div>";
  }

  function rendreRecap() {
    var factur = ajoutsFacturables(etat.tier);
    var inclus = ajoutsDejaInclus(etat.tier);

    var h = "";
    h += ligne("Forfait", echappe(ZONES[etat.zone] + " " + TIERS[etat.tier]));
    h += ligne("Véhicule", echappe(etat.vehNom) + (etat.veh !== "0" ? " (+" + etat.veh + " $)" : ""));

    if (factur.length) {
      h += ligne("Ajouts", factur.map(function (c) {
        return echappe(texteAjout(c)) + " (+" + prixAjout(c) + " $)";
      }).join("<br>"));
    }
    if (inclus.length) {
      h += ligne("Déjà compris",
        inclus.map(function (c) { return echappe(texteAjout(c)); }).join("<br>") +
        '<br><span class="bk-mini">sans supplément</span>');
    }

    /* ⚠️ 2026-08-11 — ON N'ANNONCE PLUS DE DUREE ICI, et c'est voulu.
       Ce recap s'affiche AVANT que le client ait choisi son heure de depot.
       A ce moment-la, la duree d'immobilisation depend de quelque chose qu'on
       ne connait pas encore : combien de monde sera la pendant qu'on travaille
       sur son auto. Un depot a 9 h un matin a une personne et un depot a 13 h
       ne donnent pas la meme reprise, pour le meme forfait.

       L'ancienne ligne affichait `hp / 2` : un chiffre invente, qui devenait
       une promesse. La vraie heure de reprise est calculee une fois la date et
       l'heure choisies, et elle apparait sur la page merci. Vague avant,
       precis apres — decision d'Alex, 2026-08-11. */
    h += ligne("Temps à l'atelier",
      '<span class="bk-mini">on vous confirme l\'heure de reprise ' +
      'avec votre réservation</span>');

    var prix = prixAffiche();
    if (prix) h += ligne("Total", echappe(prix), "total");

    el.bkRecap.innerHTML = h;
  }

  /* ================= Calendrier ================= */

  /* Le delai minimum se compte jusqu'au DEPOT, pas jusqu'a minuit. Sans ca,
     un client peut reserver a 23 h pour le lendemain 9 h en croyant respecter
     les 24 h de delai. */
  /* 2026-09-05 — LE DELAI DEPEND DU CRENEAU VISE, plus de l'instant ou on
     regarde. Regle d'Alex : 1 h du lundi 9 h au vendredi 17 h, 24 h le reste
     du temps. Un rendez-vous de fin de semaine lui fait changer ses plans
     personnels ; il ne peut pas l'apprendre une heure d'avance.

     Le repere est la MINUTE DE LA SEMAINE du depot (jour * 1440 + minutes).
     Ca laisse une fenetre enjamber le dimanche sans cas particulier : quand
     `du` tombe apres `au`, la fenetre traverse la fin de semaine.

     RETROCOMPATIBLE : un nombre reste un nombre, et une config sans
     `fenetres` se comporte exactement comme avant. */
  function minuteSemaine(jour, min) { return jour * 1440 + min; }

  function delaiDepot(jour, min) {
    var D = R.delaiMinimumHeures;
    if (typeof D === "number") return D;
    if (!D || typeof D !== "object") return 24;
    var mow = minuteSemaine(jour, min);
    var f = D.fenetres || [];
    for (var i = 0; i < f.length; i++) {
      if (!f[i] || !f[i].du || !f[i].au) continue;
      var a = minuteSemaine(f[i].du[0], minutes(f[i].du[1]));
      var b = minuteSemaine(f[i].au[0], minutes(f[i].au[1]));
      var dedans = (a <= b) ? (mow >= a && mow < b) : (mow >= a || mow < b);
      if (dedans && typeof f[i].heures === "number") return f[i].heures;
    }
    return typeof D.defaut === "number" ? D.defaut : 24;
  }

  /* Le delai se compte jusqu'au DEPOT, pas jusqu'a minuit. Sans ca, un client
     peut reserver a 23 h pour le lendemain 9 h en croyant respecter le delai. */
  function depotPermis(d, t) {
    var quand = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, t, 0, 0);
    return quand.getTime() - Date.now() >= delaiDepot(d.getDay(), t) * 3600000;
  }

  /* Conserve pour `SA_BOOKING` et tout appelant qui veut le plancher global.
     Sans argument il rend celui du delai par defaut, comme avant. */
  function limiteBasse(jour, min) {
    var d = new Date();
    var D = R.delaiMinimumHeures;
    var h = (typeof jour === "number") ? delaiDepot(jour, min || 0)
          : (typeof D === "number" ? D
             : ((D && typeof D.defaut === "number") ? D.defaut : 24));
    d.setTime(d.getTime() + h * 3600000);
    return d;
  }

  /* v8 — Abonne d'entretien, lu sur les PLANS et plus du tout sur les tags.

     Ce qui remplace quoi. La version 7 cherchait un tag client commencant par
     `entretien-` avec une echeance en suffixe. Elle n'a jamais rendu true une
     seule fois : `window.SA_CLIENT` n'etait pose nulle part dans le theme, et
     aucun client ne portait de tag `entretien-`. Le remplacer ne casse donc
     rien — c'etait un mort-ne, pas un mort a enterrer.

     La verite est le metaobjet `plan`, injecte par `snippets/v2-client.liquid`.

     ⚠️ PLUS AUCUNE ECHEANCE A DECODER. Un plan qui se termine passe a
     statut "termine" : c'est un ETAT, pose par l'ecran Abonnes de l'app, pas
     une date a parser dans une chaine de caracteres. Le jour ou un plan expire
     sans que personne ne change son statut, il reste actif ici — c'est voulu :
     ce systeme prefere accorder l'horizon long a tort plutot que de le refuser
     a un vrai abonne parce qu'un caractere manquait dans un tag.

     `cfg.horizon.tagAbonnePrefixe` n'est plus lu par personne. La cle reste
     dans booking_config tant qu'on n'a pas verifie que rien d'autre ne la lit. */
  function planActif() {
    var c = window.SA_CLIENT;
    if (!c || !c.connecte || !Array.isArray(c.plans)) return null;
    for (var i = 0; i < c.plans.length; i++) {
      var p = c.plans[i];
      if (p && String(p.statut == null ? "" : p.statut).toLowerCase() === "actif") return p;
    }
    return null;
  }

  function estAbonne() {
    return planActif() !== null;
  }

  /* ==========================================================================
     GESTE B (2026-08-14) — UNE RESERVATION D'ABONNE DOIT PORTER LA TRACE
     QU'IL EST ABONNE, MEME HORS DE LA PAGE ENTRETIEN.

     `window.SA_NOTE_RDV` n'etait pose que par `snippets/v2-entretien.liquid`,
     pour la creation d'une NOUVELLE adhesion. Un abonne existant qui reserve
     depuis Forfaits (ou Nano, ou le Questionnaire) ne laissait aucune trace de
     son statut : si personne ne le reconnait de memoire, il paie plein prix et
     aucun systeme ne l'attrape.

     Meme mecanisme que la page Entretien (`window.SA_NOTE_RDV`, meme format
     multi-lignes) — mais on NE TOUCHE JAMAIS au prix affiche : changer un
     total en silence est une decision d'affaires qu'Alex n'a pas tranchee. On
     pose une note, rien de plus. */
  function noteAbonneHorsEntretien(p) {
    return [
      "ABONNÉ — réservation prise hors page Entretien",
      "Formule : " + (p.formule || "?") + (p.niveau ? " (" + p.niveau + ")" : ""),
      "Rythme : " + (p.rythme || "?"),
      "Véhicule (plan) : " + (p.vehicule || "?"),
      "Prix par passage (plan) : " + (p.prix_passage != null ? p.prix_passage + " $" : "?"),
      "Prochain passage prévu : " + (p.prochain_passage || "?"),
      "⚠️ Prix NON modifié automatiquement — vérifier si ce rendez-vous doit être facturé au tarif du plan."
    ].join("\n");
  }

  /* v7 — Horizon par forfait. Un gros forfait ne rentre que dans quelques
     journees par mois : il doit pouvoir reserver loin. Un petit rentre
     partout, meme demain. Le critere est la difficulte a replacer, pas le
     prix : la rentabilite se gere par le prix, pas par le calendrier. */
  /* 2026-09-09 — LE PREMIER PASSAGE D'UN ENTRETIEN VOIT PLUS LOIN QUE LE
     BRONZE QU'IL EMPRUNTE. La page Entretien n'a pas de forfait a elle : elle
     ouvre ce panneau par le pont `#ent-pont #tier-bronze`, donc `cleForfait()`
     rend `both_bronze` ou `ext_bronze` — exactement les clefs des Bronze
     ponctuels de /pages/forfaits. Monter la clef aurait ouvert les deux.

     Trois conditions, et les trois comptent :
       1. la page Entretien a pose `window.SA_PREMIER_PASSAGE` (une adhesion
          est en cours, pas une reservation ordinaire) ;
       2. la clef est bien une des deux clefs de mise a niveau — sans ca, un
          drapeau qui traine ouvrirait un Int&Ext Or a la meme distance ;
       3. `horizon.premierPassage` est un NOMBRE. Absent ou vide, on ne fait
          rien : le comportement d'avant ce jour revient tout seul.
     Comme l'horizon abonne, ca n'ecrase que VERS LE HAUT. */
  var CLES_MISE_A_NIVEAU = { both_bronze: 1, ext_bronze: 1 };

  function horizonJoursForfait() {
    var H = cfg.horizon || {};
    var cle = cleForfait();
    var n = H.parForfait && H.parForfait[cle];
    if (typeof n !== "number") n = (typeof H.defaut === "number" ? H.defaut : (R.horizonJours || 60));
    if (window.SA_PREMIER_PASSAGE === true && CLES_MISE_A_NIVEAU[cle]
        && typeof H.premierPassage === "number" && H.premierPassage > n) n = H.premierPassage;
    if (estAbonne() && typeof H.abonne === "number" && H.abonne > n) n = H.abonne;
    return n;
  }

  function limiteHaute() {
    var d = new Date();
    d.setDate(d.getDate() + horizonJoursForfait());
    d.setHours(23, 59, 59, 999);
    return d;
  }

  /* Une journee est reservable s'il reste assez d'heures pour le PIRE cas,
     s'il reste une place, et si au moins un creneau de depot tient dans
     la fenetre d'ouverture apres le delai minimum. */
  function jourReservable(d, besoinMax) {
    if (d > limiteHaute()) return false;
    if (placesRestantes(d) <= 0) return false;
    if (heuresRestantes(d) < besoinMax) return false;
    return creneaux(d, besoinMax).length > 0;
  }

  /* v7 — Anti-fragmentation. Un petit forfait depose au milieu d'une journee
     coupe la grande plage en deux : un Ext Bronze a 11h peut rendre un
     Int&Ext Or de 9 h-p impossible, soit 4 h-p perdues. On ne lui offre donc
     que les deux bouts de la journee. DEUX relachements (Alex, 2026-07-30) :
     (1) dans la zone libre on remplit sans contrainte — une plage gardee
     libre a J-3 a peu de chances d'etre prise par un gros job, la proteger
     revient a choisir le vide ; (2) si la journee a deja moins que le plus
     gros gabarit en heures libres, la grande plage est deja detruite et il
     n'y a plus rien a proteger. */
  function bordureSeulement(d, besoinMax) {
    var P = cfg.placement;
    if (!P || typeof P.petitForfaitSeuilHp !== "number") return false;
    if (besoinMax >= P.petitForfaitSeuilHp) return false;
    var zl = typeof P.zoneLibreJours === "number" ? P.zoneLibreJours : 0;
    var lim = new Date(); lim.setDate(lim.getDate() + zl); lim.setHours(23,59,59,999);
    if (d <= lim) return false;
    if (typeof P.gabaritMaxHp === "number" && heuresRestantes(d) < P.gabaritMaxHp) return false;
    return true;
  }

  /* Creneaux de depot possibles ce jour-la. */
  function creneaux(d, besoinMax) {
    var ouv = ouvertureDu(d)   /* v10 : horaire effectif du jour */;
    if (!ouv) return [];

    var pas = R.pasMinutes || 30;
    var debut = minutes(ouv[0]);
    var fin = minutes(ouv[1]);
    var tampon = R.tamponMinutes || 0;

    /* Le depot ne peut pas etre dans le passe ni avant le delai minimum.
       2026-09-05 : le delai depend desormais du creneau vise, il se teste donc
       creneau par creneau et non plus une fois pour toute la journee. Un
       vendredi peut ainsi offrir 16 h a 1 h d'avance et refuser 17 h, qui en
       demande 24. Le pre-calcul d'un `plancher` unique ne pouvait pas dire ca. */

    /* ⚠️ 2026-08-11 — CHAQUE CRENEAU EST TESTE POUR LUI-MEME.
       Avant, un seul « dernier depot possible » etait calcule avec `hp / 2`,
       le meme pour toute la journee. Ca supposait que le rythme de travail est
       constant du matin au soir. Il ne l'est pas : un depot a 9 h un matin ou
       une seule personne est la peut ne PAS rentrer avant la fermeture, alors
       que le meme forfait depose a 13 h rentre sans probleme.

       On teste donc chaque heure de depot une par une. Le site cesse d'offrir
       des cases qui ne tiennent pas — et il cesse d'en refuser qui tiennent. */
    var jour = d.getDay();
    var dISO = iso(d);
    var out = [];
    for (var t = debut; t + pas <= fin; t += pas) {
      if (!depotPermis(d, t)) continue;
      var immo = immobilisation(jour, t, besoinMax, dISO);
      if (immo.fin > fin - tampon) continue;
      /* GESTE A : ecarte le creneau si sa plage chevauche un rendez-vous deja
         pris ce jour-la. On ne montre jamais une place deja vendue. */
      if (rdvChevauchants(dISO, t, immo.fin - t)) continue;
      out.push(t);
    }
    /* Journee entiere : le vehicule reste plus longtemps que la fenetre, mais
       le travail se poursuit le lendemain. On propose l'ouverture, en le disant. */
    if (!out.length && depotPermis(d, debut)) {
      var immoDebut = immobilisation(jour, debut, besoinMax, dISO);
      if (!rdvChevauchants(dISO, debut, immoDebut.fin - debut)) out.push(debut);
    }

    if (out.length > 2 && bordureSeulement(d, besoinMax)) out = [out[0], out[out.length - 1]];
    return out;
  }

  function rendreCalendrier() {
    var besoin = dureeHP().max;
    var an = moisAffiche.getFullYear(), mois = moisAffiche.getMonth();
    el.bkMois.textContent = MOIS[mois] + " " + an;

    var h = JOURS.map(function (j) { return '<span class="bk-jour-nom">' + j + "</span>"; }).join("");
    var premier = new Date(an, mois, 1);
    for (var i = 0; i < premier.getDay(); i++) h += '<span class="bk-jour vide"></span>';

    var nbJours = new Date(an, mois + 1, 0).getDate();
    var auMoinsUn = false;

    for (var n = 1; n <= nbJours; n++) {
      var d = new Date(an, mois, n);
      var ok = jourReservable(d, besoin);
      if (ok) auMoinsUn = true;
      var actif = etat.date && memeJour(d, etat.date);
      h += '<button type="button" class="bk-jour' + (actif ? " on" : "") + '" data-date="' + iso(d) + '"' +
        (ok ? "" : " disabled") + (actif ? ' aria-current="date"' : "") +
        ' aria-label="' + n + " " + MOIS[mois] + (ok ? " - disponible" : " - complet") + '">' +
        n + (ok ? "<i></i>" : "") + "</button>";
    }
    el.bkGrille.innerHTML = h;

    var moisCourant = new Date();
    el.bkPrec.disabled = (mois === moisCourant.getMonth() && an === moisCourant.getFullYear()) ||
      new Date(an, mois + 1, 0) < moisCourant;
    el.bkSuiv.disabled = new Date(an, mois, 1) > limiteHaute();

    /* Aucun cul-de-sac : le client sait toujours quoi faire ensuite. */
    if (!auMoinsUn) {
      var suite = el.bkSuiv.disabled ? "" :
        ' <button type="button" class="bk-lien" id="bkVersSuivant">Voir ' + MOIS[(mois + 1) % 12] + "</button>.";
      el.bkNote.innerHTML = '<strong>Rien de libre en ' + MOIS[mois] + " pour ce forfait.</strong>" + suite +
        ' Ou appelez-nous au <a href="tel:' + TEL_LIEN + '">' + TEL + "</a> - on trouve toujours une solution.";
      var b = document.getElementById("bkVersSuivant");
      if (b) b.addEventListener("click", moisSuivant);
    } else {
      el.bkNote.innerHTML = "Un point doré signale une journée où il nous reste assez de temps pour traiter " +
        "votre véhicule correctement. On ne prend jamais plus de rendez-vous que ce qu'on peut faire.";
    }
  }

  function rendreHeures() {
    if (!etat.date) { el.bkBlocHeures.hidden = true; return; }
    var options = creneaux(etat.date, dureeHP().max);
    if (!options.length) { el.bkBlocHeures.hidden = true; return; }

    el.bkBlocHeures.hidden = false;
    el.bkHeures.innerHTML = options.map(function (t) {
      return '<button type="button" class="bk-heure' + (etat.heure === t ? " on" : "") +
        '" data-min="' + t + '"' + (etat.heure === t ? ' aria-pressed="true"' : "") + ">" + hhmm(t) + "</button>";
    }).join("");
  }

  function majBouton() {
    var pret = !!(etat.date && etat.heure !== null) && !etat.envoi;
    el.bkConfirmer.disabled = !pret;
    if (etat.envoi) { el.bkConfirmer.textContent = "Un instant..."; return; }
    el.bkConfirmer.textContent = pret
      ? "Confirmer le " + etat.date.getDate() + " " + MOIS[etat.date.getMonth()] + " à " + hhmm(etat.heure)
      : (etat.date ? "Choisissez une heure" : "Choisissez une date");
  }

  /* ================= Coordonnees ================= */

  /* Toutes obligatoires depuis le 2026-08-04. Avant, on pouvait reserver sans
     laisser de quoi rappeler qui que ce soit : le jour ou il fallait deplacer
     un rendez-vous, il n'y avait personne au bout du fil.

     Le bouton n'est PAS desactive tant que les champs sont vides : un bouton
     gris qui ne dit pas pourquoi est pire qu'un message clair au clic. */

  var COURRIEL_OK = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /* Chaque champ porte sa propre regle et son propre message. Un « remplissez
     tous les champs » oblige le client a chercher lequel. */
  var CHAMPS = [
    { entree: "bkPrenom",   erreur: "bkErrPrenom",   test: function (v) { return v.length >= 2; } },
    { entree: "bkNom",      erreur: "bkErrNom",      test: function (v) { return v.length >= 2; } },
    { entree: "bkTel",      erreur: "bkErrTel",      test: function (v) { return v.replace(/\D/g, "").length >= 10; } },
    { entree: "bkCourriel", erreur: "bkErrCourriel", test: function (v) { return COURRIEL_OK.test(v); } },
    { entree: "bkAdresse",  erreur: "bkErrAdresse",  test: function (v) { return v.length >= 5; } }
  ];

  function valeur(id) { return ((el[id] && el[id].value) || "").trim(); }

  function validerChamp(c, silencieux) {
    var v = valeur(c.entree);
    /* Silencieux : on ne crie pas sur un champ que le client n'a pas encore
       touche. Le rouge apparait quand il quitte le champ, ou au clic final. */
    var vide = v.length === 0;
    var bon = c.test(v);
    if (silencieux && vide) { cacherErreur(c); return false; }
    if (el[c.erreur]) el[c.erreur].hidden = bon;
    if (el[c.entree]) el[c.entree].setAttribute("aria-invalid", bon ? "false" : "true");
    return bon;
  }
  function cacherErreur(c) {
    if (el[c.erreur]) el[c.erreur].hidden = true;
    if (el[c.entree]) el[c.entree].setAttribute("aria-invalid", "false");
  }

  /* Rend le premier champ fautif, pour y amener le client directement. */
  /* 2026-09-09 — LIEN D'INVITATION. Quand la page a pose `window.SA_PLAN`,
     les coordonnees sont deja connues cote serveur : le postier les lira dans
     le plan. On ne demande donc rien, et on ne valide rien — valider des
     champs caches interdirait de confirmer, sans jamais dire pourquoi. */
  function planInvitation() {
    var p = window.SA_PLAN;
    return (p && p.id) ? String(p.id).replace(/\D/g, "") : "";
  }

  function premierChampFautif() {
    if (planInvitation()) return null;
    for (var i = 0; i < CHAMPS.length; i++) {
      if (!validerChamp(CHAMPS[i], false)) return CHAMPS[i];
    }
    return null;
  }

  /* ================= Escalade ================= */

  /* Rien ne doit echouer en silence.

     2026-08-04 : cette fonction passait par /contact — donc chaque alerte
     echouait elle aussi, silencieusement. Une panne muette qui signalait ses
     pannes dans le vide. Elle parle maintenant au postier, qui envoie un vrai
     courriel. Le robot de facturation PCX a attendu 250 fois sans alerter
     personne : pas deux fois. */
  function crier(sujet, detail) {
    if (window.console) console.error("[booking] " + sujet, detail);
    var charge = {
      action: "alerte",
      sujet: sujet,
      detail: String(detail),
      contexte: {
        client: valeur("bkPrenom") + " " + valeur("bkNom"),
        courriel: valeur("bkCourriel"),
        tel: valeur("bkTel"),
        forfait: ZONES[etat.zone] + " " + TIERS[etat.tier] + " - " + etat.vehNom,
        date: etat.date ? iso(etat.date) : "?",
        heure: etat.heure !== null ? hhmm(etat.heure) : "?",
        navigateur: navigator.userAgent
      }
    };
    /* GESTE C (2026-08-14) — UNE ALERTE QUI ECHOUE NE DOIT PAS DISPARAITRE.
       Avant : un seul essai (`envoyerAuPostier`, pas `envoyerAvecReprises`) et
       un `.catch` muet qui avalait l'echec sans rien garder. C'est exactement
       le mode de panne qui a laisse une facture PCX de ~510 $ bloquee 17 jours
       sans que personne ne soit prevenu : le mecanisme cense alerter a echoue
       sans alerter de son propre echec. Meme principe que la file de
       reservations en attente ci-dessous (memes trois essais via
       `envoyerAvecReprises`, meme repli localStorage, cle separee) : une
       alerte injoignable est gardee et repart toute seule au prochain
       chargement de page plutot que de se volatiliser. */
    try {
      envoyerAvecReprises(charge).catch(function () { poserAlerteEnFile(charge); });
    } catch (e) {
      try { poserAlerteEnFile(charge); } catch (e2) { /* rien de plus a faire */ }
    }
  }

  function alerter(html) {
    el.bkAlerte.innerHTML = html;
    el.bkAlerte.hidden = false;
    el.bkAlerte.scrollIntoView({ block: "nearest", behavior: "smooth" });
  }
  function effacerAlerte() { el.bkAlerte.hidden = true; el.bkAlerte.innerHTML = ""; }

  /* ================= Le postier ================= */

  /* `text/plain` volontairement : tout autre type declencherait un controle
     prealable CORS qu'Apps Script ne sait pas honorer. */
  function envoyerAuPostier(charge) {
    return fetch(POSTIER, {
      method: "POST",
      redirect: "follow",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify(charge)
    }).then(function (r) {
      if (!r.ok) throw new Error('postier HTTP ' + r.status);
      return r.json();
    });
  }

  /* Trois tentatives, espacees. Un reseau de telephone qui vacille une seconde
     ne doit pas couter une reservation. */
  function envoyerAvecReprises(charge, essai) {
    essai = essai || 1;
    return envoyerAuPostier(charge).catch(function (err) {
      if (essai >= ESSAIS_MAX) throw err;
      return new Promise(function (ok) { setTimeout(ok, essai * 1200); })
        .then(function () { return envoyerAvecReprises(charge, essai + 1); });
    });
  }

  /* ================= Panier (abonnement / entretien recurrent) ================= */

  /* 2026-08-14 — LE GREFFON PANIER. Quand une page pose window.SA_ABONNEMENT
     avant que le client clique Confirmer, la reservation ne part PLUS
     directement au postier : elle part au panier Shopify, avec le forfait
     (date/heure/vehicule) attache en PROPRIETES de la ligne. C'est la caisse
     Shopify qui encaisse et qui garde la carte — c'est la SEULE porte qui le
     fait. Le postier apprendra la reservation plus tard, tout seul, en lisant
     les proprietes de la commande (synchroniserAbonnements(), cote Postier).

     Forme attendue de window.SA_ABONNEMENT :
       { variantId: 123456789, sellingPlanId: 987654321, proprietes: {...} }
     variantId et sellingPlanId sont NUMERIQUES, jamais des GID.
     Si l'un des deux manque, on NE PART PAS au panier : chemin normal
     (direct au postier) conserve — une reservation ne doit jamais devenir
     invisible parce qu'un ID d'abonnement manque. */
  function refWeb() {
    return "WEB-" + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  function envoyerAuPanier(abo, rdv) {
    /* rdv.vehicule est deja la CLE stockee (berline/vus/camionnette), pas le
       libelle affiche — voir CODE_VERS_VEH en tete de fichier. Ne pas la
       remplacer par etat.vehNom ici : ce serait reintroduire le meme piege
       cote panier. */
    var proprietes = { "_ref": refWeb(), "Date": rdv.date, "Heure": rdv.heure, "Véhicule": rdv.vehicule };
    if (rdv.note) proprietes["Note"] = rdv.note;
    if (abo.proprietes) Object.keys(abo.proprietes).forEach(function (k) { proprietes[k] = abo.proprietes[k]; });

    /* 🔴 2026-09-09 — ON VIDE LE PANIER AVANT D'AJOUTER, ET C'EST OBLIGATOIRE.
       Trouve par le test de bout en bout : la commande #1389 portait CINQ
       articles au lieu d'un. Chaque tentative abandonnee restait dans le
       panier — deux essais du meme entretien, un essai d'une autre date, et
       deux abonnements d'une session vieille de la veille — et le checkout
       final les a TOUS achetes.

       Ce qui rend ca dangereux plutot que sale : le premier cycle est a 0 $.
       Le client voit « 0,00 $ », valide, et se retrouve avec trois contrats
       d'abonnement dont aucun ne se voit avant le PREMIER VRAI PRELEVEMENT.
       Un mois plus tard, il est preleve trois fois et conteste sa carte.

       Vider est le bon geste ici et pas ailleurs : ce chemin est un tunnel
       d'adhesion dedie, pas une boutique ou l'on accumule. Un client qui
       arrive ici vient souscrire a UN entretien, un seul. */
    return fetch("/cart/clear.js", { method: "POST" })
      .catch(function () { /* panier deja vide, ou endpoint indisponible : on
        continue quand meme. Echouer ici couterait la vente ; le pire cas
        redevient simplement le comportement d'avant ce correctif. */ })
      .then(function () {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: abo.variantId, quantity: 1, selling_plan: abo.sellingPlanId, properties: proprietes }] })
        });
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error((e && e.description) || "cart/add refuse"); });
        return r.json();
      });
  }

  /* ================= File de secours ================= */

  /* Si le postier est injoignable apres trois essais, la reservation est gardee
     dans le navigateur du client et repart toute seule au prochain chargement
     de page. C'est ce qui remplace le filet par courriel de Shopify : il ne
     depend de personne d'autre que du client qui revient. */
  function file() {
    try { return JSON.parse(localStorage.getItem(CLE_FILE) || "[]"); } catch (e) { return []; }
  }
  function poserEnFile(charge) {
    try {
      var f = file();
      /* Meme date + meme heure + meme courriel = meme rendez-vous. Le postier
         dedoublonne aussi de son cote, mais autant ne pas le faire travailler. */
      var cle = charge.rdv.date + charge.rdv.heure + charge.rdv.courriel;
      if (f.some(function (x) { return (x.rdv.date + x.rdv.heure + x.rdv.courriel) === cle; })) return;
      f.push(charge);
      localStorage.setItem(CLE_FILE, JSON.stringify(f.slice(-5)));
    } catch (e) { /* pas de localStorage : on a deja montre le telephone */ }
  }
  function viderLaFile() {
    var f = file();
    if (!f.length) return;
    try { localStorage.removeItem(CLE_FILE); } catch (e) {}
    f.forEach(function (charge) {
      envoyerAvecReprises(charge)
        .then(function (o) {
          if (o && o.ok) {
            if (window.console) console.info("[booking] réservation en attente rattrapée · " + o.ref);
          } else if (!o || !o.refus) { poserEnFile(charge); }
          /* Un refus (date passee, forme invalide) ne se retente pas : il
             echouerait a l'identique jusqu'a la fin des temps. */
        })
        .catch(function () { poserEnFile(charge); });
    });
  }

  /* GESTE C — meme file de secours que les reservations ci-dessus, mais pour
     les alertes qui echouent apres trois essais. Cle localStorage separee
     pour ne jamais melanger une alerte avec une reservation. */
  function fileAlertes() {
    try { return JSON.parse(localStorage.getItem(CLE_FILE_ALERTES) || "[]"); } catch (e) { return []; }
  }
  function poserAlerteEnFile(charge) {
    try {
      var f = fileAlertes();
      var cle = charge.sujet + "|" + charge.detail + "|" + ((charge.contexte && charge.contexte.courriel) || "");
      if (f.some(function (x) { return (x.sujet + "|" + x.detail + "|" + ((x.contexte && x.contexte.courriel) || "")) === cle; })) return;
      f.push(charge);
      localStorage.setItem(CLE_FILE_ALERTES, JSON.stringify(f.slice(-5)));
    } catch (e) { /* pas de localStorage : deja loggee en console au moins */ }
  }
  function viderLaFileAlertes() {
    var f = fileAlertes();
    if (!f.length) return;
    try { localStorage.removeItem(CLE_FILE_ALERTES); } catch (e) {}
    f.forEach(function (charge) {
      envoyerAvecReprises(charge).catch(function () { poserAlerteEnFile(charge); });
    });
  }

  /* ================= Confirmation ================= */

  function montantNumerique() {
    var t = prixAffiche() || "";
    var m = String(t).replace(/\s/g, "").match(/(\d+(?:[.,]\d{1,2})?)/);
    return m ? parseFloat(m[1].replace(",", ".")) : 0;
  }

  function confirmerReservation() {
    if (etat.envoi) return;
    effacerAlerte();

    var fautif = premierChampFautif();
    if (fautif) {
      if (el[fautif.entree]) {
        el[fautif.entree].focus();
        el[fautif.entree].scrollIntoView({ block: "center", behavior: "smooth" });
      }
      return;
    }

    var prenom  = valeur("bkPrenom");
    var nom     = valeur("bkNom");
    var mail    = valeur("bkCourriel");
    var tel     = valeur("bkTel");
    var adresse = valeur("bkAdresse");

    var dISO = iso(etat.date);
    var hHM  = ("0" + Math.floor(etat.heure / 60)).slice(-2) + ":" + ("0" + (etat.heure % 60)).slice(-2);
    var duree = dureeHP();
    /* ⭐ ICI on connait enfin tout : la date, l'heure de depot, le forfait et
       le vehicule. C'est le premier moment ou une heure de reprise peut etre
       calculee honnetement — d'ou le choix de ne rien annoncer avant. */
    var jourRdv = etat.date.getDay();
    var dISORdv = iso(etat.date);
    var immo = immobilisation(jourRdv, etat.heure, duree.max, dISORdv);
    var immoMin = immobilisation(jourRdv, etat.heure, duree.min, dISORdv);
    var pretHM = ("0" + (Math.floor(immo.fin / 60) % 24)).slice(-2) + ":" +
                 ("0" + (immo.fin % 60)).slice(-2);
    var lendemain = immo.fin >= 1440;
    var montant = montantNumerique();
    var ajouts = ajoutsFacturables(etat.tier);

    var charge = {
      action: "reserver",
      rdv: {
        date: dISO,
        heure: hHM,
        forfait: cleForfait(),
        /* Cle stockee (berline/vus/camionnette), PAS etat.vehNom (le libelle
           affiche au client) — voir le piege documente pres de CODE_VERS_VEH
           plus haut. Ce meme charge.rdv.vehicule part aussi dans les
           proprietes du panier via envoyerAuPanier() plus bas : corriger ici
           corrige les deux chemins (postier direct ET panier Shopify). */
        vehicule: CODE_VERS_VEH[etat.veh] || "berline",
        ajouts: ajouts,
        hp: Math.round(duree.max * 100) / 100,
        hpmin: Math.round(duree.min * 100) / 100,
        immobilisation: Math.round(immo.heures * 10) / 10,
        pret: pretHM,
        pretLendemain: lendemain,
        montant: montant,
        prenom: prenom,
        nom: nom,
        client: prenom + " " + nom,
        courriel: mail,
        tel: tel,
        adresse: adresse
      }
    };

    /* 2026-08-12 — Canal de note optionnel. Une page peut poser
       `window.SA_NOTE_RDV` avant d'ouvrir le panneau pour joindre du contexte
       a la reservation ; le champ `note` du metaobjet `reservation` existe
       depuis toujours et le postier le traite deja (max 500 car.).
       Aujourd'hui, seule la page Entretien s'en sert : elle y met le plan que
       le client vient d'activer, sans quoi sa mise a niveau arriverait dans
       l'agenda comme un forfait ordinaire.
       ⚠️ Absente ailleurs = `undefined` : Forfaits, Nano et Questionnaire
       envoient exactement la meme charge qu'avant. */
    if (window.SA_NOTE_RDV) charge.rdv.note = String(window.SA_NOTE_RDV).slice(0, 500);

    /* 2026-09-09 — L'identifiant du plan voyage a la place des coordonnees.
       Le postier remplit nom, courriel et telephone depuis la fiche client
       rattachee au plan (`clientDuPlan()`), et refuse proprement si le plan
       n'existe pas. Absent = charge identique a avant, pour tout le monde. */
    var planInv = planInvitation();
    if (planInv) charge.rdv.plan = planInv;

    /* 2026-08-13 — LE JOINT ENTRE UN ABONNE ET SES PASSAGES.
       Le metaobjet `reservation` porte un champ `client_id` depuis le
       2026-08-11, mais RIEN ne le remplissait : ni le theme, ni le postier.
       Une reservation ne pointait donc vers aucun client Shopify, et l'ecran
       Abonnes de l'app ne pouvait jamais dire « reserve » — chaque plan
       serait reste « a relancer » pour toujours.

       On envoie le numero brut ; c'est le postier qui recompose le GID, et
       qui n'accepte que des chiffres. La valeur vient du navigateur : elle ne
       merite aucune confiance, et un client_id force ne fait de toute facon
       que salir la liste de quelqu'un d'autre — aucun prix n'en depend.

       Visiteur non connecte : le champ reste absent, exactement comme avant. */
    var idClient = window.SA_CLIENT && window.SA_CLIENT.connecte && window.SA_CLIENT.id;
    if (idClient) {
      var numClient = String(idClient).replace(/\D/g, "");
      if (numClient) charge.rdv.clientId = numClient;
    }

    /* La page merci ne recoit NI courriel NI telephone dans son URL. Une URL
       finit dans les journaux du serveur, l'historique et les referents. */
    /* 2026-08-26 — D'OU VIENT CE CLIENT. Pose par le bloc SA-SOURCE de
       `theme.liquid` a l'arrivee sur le site. Fenetre de 7 jours : c'est
       celle de l'attribution au clic de Meta, pour que les deux mesures
       parlent de la meme chose. Vide = on ne sait pas, et l'URL est alors
       exactement celle d'avant ce changement. */
    var srcVisite = sourceVisite();

    /* 2026-09-09 — LA SOURCE MONTE AUSSI JUSQU'AU POSTIER, pas seulement dans
       l'URL de la page merci. Depuis le 2026-09-08 le postier declare lui-meme
       la conversion a Meta ; sans cette ligne il ne sait pas d'ou vient le
       client, donc il ne peut pas distinguer ce que Meta a merite de ce qu'il
       s'attribue. C'est une ETIQUETTE deja nettoyee plus haut (lettres,
       chiffres, tiret, 20 caracteres max) — jamais un identifiant de clic, la
       decision du 2026-08-26 tient. Absente = champ absent, charge identique
       a avant. */
    if (srcVisite) charge.rdv.src = srcVisite;

    var urlMerci = "/pages/merci?rdv=1" +
      (srcVisite ? "&src=" + encodeURIComponent(srcVisite) : "") +
      "&d=" + encodeURIComponent(dISO) +
      "&h=" + encodeURIComponent(hHM) +
      "&f=" + encodeURIComponent(ZONES[etat.zone] + " " + TIERS[etat.tier]) +
      "&v=" + encodeURIComponent(etat.vehNom || "") +
      "&m=" + encodeURIComponent(montant) +
      /* `pret` est une HEURE, pas une fourchette. Une heure se retient, se
         note et se verifie ; « 3 à 5 heures » oblige le client a faire le
         calcul lui-meme et a se tromper. `dmin`/`dmax` restent pour que la
         page merci non encore mise a jour continue de fonctionner. */
      "&pret=" + encodeURIComponent(pretHM) +
      (lendemain ? "&j1=1" : "") +
      "&dmin=" + encodeURIComponent(nombre(immoMin.heures)) +
      "&dmax=" + encodeURIComponent(nombre(immo.heures)) +
      "&p=" + encodeURIComponent(prenom);

    etat.envoi = true;
    majBouton();

    /* GREFFE PANIER : consommee IMMEDIATEMENT — jamais de fuite vers la
       reservation suivante dans la meme page. Ne s'active QUE si les deux
       ID sont presents ; aujourd'hui aucun sellingPlanId n'existe encore,
       donc ce chemin ne part jamais et tout suit le chemin normal ci-dessous. */
    var abo = window.SA_ABONNEMENT;
    window.SA_ABONNEMENT = null;
    if (abo && abo.variantId && abo.sellingPlanId) {
      /* ⚠️ 2026-09-09 — LE POSTIER D'ABORD, LE PANIER ENSUITE.
         Jusqu'a ce jour, ce chemin partait DROIT au panier et retournait :
         le postier n'etait jamais appele. Consequence, verifiee ligne par
         ligne le 2026-09-09 : le client choisissait sa date, payait 0 $, sa
         carte etait enregistree — et son rendez-vous n'existait NULLE PART.
         Aucun metaobjet `reservation`, aucun creneau bloque, aucune entree
         d'agenda, aucune confirmation. Sa date ne vivait que dans les
         proprietes de la commande Shopify.

         Et aucun filet ne rattrapait : le balayage Gmail cherche des lignes
         `RDV-DATE:` que seul l'ancien chemin produit, et le hook de rattrapage
         vit sur `/pages/merci`, que ce parcours ne visite jamais — il va sur
         `/checkout`.

         L'ORDRE EST CHOISI, PAS SUBI. Des deux echecs possibles :
           · rendez-vous ecrit puis checkout abandonne = un creneau a annuler,
             visible dans l'app, le plan restant a `mise_a_niveau_faite: false` ;
           · checkout paye puis rendez-vous nulle part = un client qui a donne
             sa carte, croit avoir un rendez-vous, et dont le creneau sera
             vendu a quelqu'un d'autre.
         Le second est bien pire. On ecrit donc d'abord, et on n'envoie au
         panier que si le postier a dit oui. */
      envoyerAvecReprises(charge)
        .then(function (o) {
          if (o && o.ok) return envoyerAuPanier(abo, charge.rdv);
          /* Refus explicite (capacite, date hors horizon, forfait inconnu) :
             la date n'est pas valide, donc on ne prend surtout pas la carte. */
          var raison = (o && o.erreur) ? String(o.erreur) : "raison inconnue";
          if (!(o && o.complet)) crier("réservation refusée par le postier (chemin abonnement)", raison);
          var refus = new Error(raison);
          refus.refusPostier = true;
          throw refus;
        })
        .then(function () { window.location.assign("/checkout"); })
        .catch(function (err) {
          etat.envoi = false; majBouton();
          if (err && err.refusPostier) {
            alerter("On n'a pas pu retenir cette date : <strong>" + echappe(err.message) +
              "</strong>. Choisissez-en une autre, ou appelez-nous au " +
              '<a href="tel:' + TEL_LIEN + '">' + TEL + "</a> — on le prend au téléphone tout de suite.");
          } else {
            /* Transport en panne, ou panier refuse. On garde la demande en
               file comme le chemin normal, et on NE PART PAS au checkout :
               prendre une carte pour un rendez-vous qu'on n'a pas su ecrire
               est exactement ce qu'on vient de corriger. */
            poserEnFile(charge);
            alerter("On n'a pas réussi à joindre notre système. <strong>Votre demande est gardée " +
              "en mémoire</strong> et repartira toute seule. Pour en avoir le cœur net tout de suite, " +
              'appelez-nous au <a href="tel:' + TEL_LIEN + '">' + TEL + "</a>." +
              '<br><span style="opacity:.55;font-size:.82em">' +
              echappe((err && err.message) || String(err)) + "</span>");
          }
          el.bkConfirmer.textContent = "Réessayer"; el.bkConfirmer.disabled = false;
        });
      return;
    }

    envoyerAvecReprises(charge)   /* INCHANGÉ — le chemin actuel, pour tout le reste */
      .then(function (o) {
        if (o && o.ok) {
          /* Note AVANT de quitter la page : c'est ici qu'on connait encore le
             forfait. La file part toute seule au `pagehide` de la navigation. */
          geste("merci", cleForfait());
          window.location.assign(urlMerci);
          return;
        }

        /* Refus explicite du postier : la reservation n'est PAS valide. La
           retenter ne changerait rien — on le dit au client tout de suite. */
        etat.envoi = false;
        majBouton();
        var raison = (o && o.erreur) ? String(o.erreur) : "raison inconnue";
        /* Une journee pleine n'est pas une panne : c'est le systeme qui fait
           son travail. Crier dessus remplirait la boite d'alertes normales, et
           une alerte qui sonne pour du normal finit par ne plus etre lue. On
           ne previent que pour ce qui n'aurait pas du arriver. */
        if (!(o && o.complet)) crier("réservation refusée par le postier", raison);
        alerter("On n'a pas pu retenir cette date : <strong>" + echappe(raison) + "</strong>. " +
          'Choisissez-en une autre, ou appelez-nous au <a href="tel:' + TEL_LIEN + '">' + TEL +
          "</a> - on le prend au téléphone tout de suite.");
        el.bkConfirmer.textContent = "Réessayer";
        el.bkConfirmer.disabled = false;
      })
      .catch(function (err) {
        /* Injoignable apres trois essais. On garde la reservation de cote : elle
           repartira toute seule si le client revient sur le site. */
        etat.envoi = false;
        majBouton();
        poserEnFile(charge);
        alerter("On n'a pas réussi à joindre notre système. <strong>Votre demande est gardée en mémoire</strong> " +
          "et repartira toute seule. Pour en avoir le coeur net tout de suite, " +
          'appelez-nous au <a href="tel:' + TEL_LIEN + '">' + TEL + "</a>." +
          '<br><span style="opacity:.55;font-size:.82em">' + echappe((err && err.message) || String(err)) + "</span>");
        el.bkConfirmer.textContent = "Réessayer";
        el.bkConfirmer.disabled = false;
      });
  }

  /* ================= Ouverture / fermeture ================= */

  function ouvrir(tier) {
    etape(3);                      /* le calendrier s'ouvre */
    var v = vehActif();
    etat.tier = tier;
    etat.zone = zoneActive();
    /* Note APRES avoir pose zone et palier : `cleForfait()` lit `etat`, donc
       l'appeler plus haut aurait donne le forfait de l'ouverture precedente. */
    geste("reserver", cleForfait());
    joursEssayes = 0;              /* un nouveau calendrier, un nouveau compte */
    etat.veh = v.code;
    etat.vehNom = v.nom;
    etat.date = null;
    etat.heure = null;
    etat.envoi = false;
    moisAffiche = new Date();
    dernierFocus = document.activeElement;
    effacerAlerte();
    CHAMPS.forEach(cacherErreur);

    /* 2026-09-09 — LIEN D'INVITATION : on cache le bloc « Vos coordonnees »
       plutot que de le preremplir. Preremplir voudrait dire faire redescendre
       le nom, le courriel et le telephone dans le navigateur, donc les exposer
       a quiconque devine un identifiant. Le postier les lit cote serveur et
       ne les renvoie jamais. Cache != optionnel : `premierChampFautif()`
       court-circuite aussi, sinon on bloquerait sur des champs invisibles. */
    if (el.bkCoordonnees) el.bkCoordonnees.hidden = !!planInvitation();

    /* GESTE B : ne pose la note d'abonne que si aucune page n'a deja pose la
       sienne (ex. v2-entretien.liquid pour une NOUVELLE adhesion) — sinon on
       ecraserait un contexte plus precis avec un contexte generique. */
    if (!window.SA_NOTE_RDV) {
      var plan = planActif();
      if (plan) window.SA_NOTE_RDV = noteAbonneHorsEntretien(plan);
    }

    el.bkSousTitre.textContent =
      ZONES[etat.zone] + " " + TIERS[tier] + " - déposez votre véhicule, on s'occupe du reste.";

    rendreRecap();
    rendreCalendrier();
    rendreHeures();
    majBouton();
    voile.classList.add("on");
    document.body.style.overflow = "hidden";
    el.bkFermer.focus();
  }

  function fermer() {
    voile.classList.remove("on");
    document.body.style.overflow = "";
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }

  function moisSuivant() {
    moisAffiche = new Date(moisAffiche.getFullYear(), moisAffiche.getMonth() + 1, 1);
    rendreCalendrier();
  }

  /* ================= Le moteur, expose (2026-09-03) ================= */

  /* Lecture seule pour la page concession. Aucune de ces fonctions n'ecrit ;
     `envoyerAvecReprises` est le seul chemin vers le postier, avec ses trois
     essais — le meme que le panneau. Le calendrier concession qui en decoule
     dit donc exactement la meme chose que celui du grand public. */
  window.SA_BOOKING = {
    cfg: cfg, res: res, R: R,
    iso: iso, minutes: minutes, hhmm: hhmm,
    capaciteJour: capaciteJour, heuresPrises: heuresPrises, heuresRestantes: heuresRestantes,
    estFerme: estFerme, estBloque: estBloque, ouvertureDu: ouvertureDu,
    immobilisation: immobilisation, limiteBasse: limiteBasse,
    /* 2026-09-08 — les CRENEAUX, pour les flottes et bureaux qui reservent
       « comme un client » (journee ET heure de depot, plage bloquee) depuis
       Mon compte. Lecture seule, memes fonctions que le panneau : l'heure
       offerte a une flotte est exactement celle qu'un particulier verrait. */
    creneaux: creneaux, rdvChevauchants: rdvChevauchants, placesRestantes: placesRestantes,
    depotPermis: depotPermis,
    envoyerAvecReprises: envoyerAvecReprises,
    DUREE_DEFAUT_MIN: DUREE_DEFAUT_MIN
  };
  if (sansPanneau) return;

  /* ================= Evenements ================= */

  ["bronze", "argent", "or"].forEach(function (tier) {
    var carte = document.getElementById("tier-" + tier);
    if (!carte) return;
    var cta = carte.querySelector('[data-slot="cta"]');
    if (!cta) return;
    cta.removeAttribute("target");
    cta.addEventListener("click", function (ev) { ev.preventDefault(); ouvrir(tier); });
  });

  /* ==========================================================================
     GESTE 1 (2026-08-14) — OUVRIR LE PANNEAU DEPUIS UN PARAMETRE D'URL.
     Le bouton « Réserver un passage » de la page compte client
     (snippets/v2-p-compte.liquid) et un lien du pied de page
     (snippets/v2-pied.liquid) renvoient vers /pages/v2-forfaits sans
     qu'aucun calendrier ne s'ouvre : cette page ne charge pas ce script et
     ne contient pas les cartes tier-* elle-meme. La redirection vers la page
     forfaits est le comportement voulu ; ce qui manquait, c'est que la page
     forfaits ouvre directement le bon palier a l'arrivee, via
     ?reserver=bronze|argent|or (et optionnellement &svc=int|ext|both pour
     preselectionner le service AVANT l'ouverture). Place juste apres la
     boucle qui accroche les CTA : les cartes tier-* sont deja dans le DOM a
     ce point du script. Enveloppe dans un try/catch et garde par un test
     d'existence de la carte visee : ce bloc ne doit jamais empecher le reste
     du moteur de fonctionner, et il ne fait rien sur une page sans cartes. */
  try {
    var paramsURL = new URLSearchParams(location.search);
    var tierVise = paramsURL.get("reserver");
    if (tierVise === "bronze" || tierVise === "argent" || tierVise === "or") {
      if (document.getElementById("tier-" + tierVise)) {
        var svcVise = paramsURL.get("svc");
        if (svcVise === "int" || svcVise === "ext" || svcVise === "both") {
          var btnSvc = document.querySelector('.switch button[data-svc="' + svcVise + '"]');
          if (btnSvc) btnSvc.click();
        }
        ouvrir(tierVise);
      }
    }
  } catch (e) { /* un parametre d'URL invalide ne doit jamais bloquer le reste */ }

  /* ==========================================================================
     PRESELECTION DEPUIS LE GUIDE (2026-08-15) — ?svc=int|ext|both&tier=bronze|argent|or
     Le guide « On vous guide » envoie ici la recommandation du client. Il ne
     doit PAS reutiliser ?reserver= ci-dessus : celui-la appelle ouvrir(), qui
     monte le panneau en modal plein ecran (body.overflow=hidden) et masque les
     autres paliers. Alex, 2026-08-15 : « j'aime mieux preselectionner, il doit
     voir d'autres options en dessous. »
     Donc ici : bon onglet de service, carte designee, amenee a l'ecran. Rien
     d'autre. Le client garde la main, le panneau s'ouvre quand LUI le decide.
     Meme garde-fou que le bloc precedent : try/catch et test d'existence, ce
     bloc ne doit jamais empecher le moteur de reservation de fonctionner. */
  try {
    var pSel = new URLSearchParams(location.search);
    var tierSel = pSel.get("tier");
    if (tierSel === "bronze" || tierSel === "argent" || tierSel === "or") {
      var carteSel = document.getElementById("tier-" + tierSel);
      if (carteSel) {
        var svcSel = pSel.get("svc");
        if (svcSel === "int" || svcSel === "ext" || svcSel === "both") {
          var ongletSel = document.querySelector('.switch button[data-svc="' + svcSel + '"]');
          /* Le clic passe par le handler de v2.js, qui re-rend les trois cartes
             (prix, durees, listes). On attend ce rendu avant de scroller. */
          if (ongletSel) ongletSel.click();
        }
        carteSel.classList.add("tier-vise");
        /* .rv part a opacity 0 tant que l'observer ne l'a pas revelee : scroller
           vers une carte invisible amenerait le client devant un rectangle vide. */
        carteSel.classList.add("vu");
        requestAnimationFrame(function () {
          carteSel.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
    }
  } catch (e) { /* idem : la preselection est un confort, jamais un point de rupture */ }

  el.bkGrille.addEventListener("click", function (ev) {
    var b = ev.target.closest && ev.target.closest(".bk-jour");
    if (!b || b.disabled || !b.dataset.date) return;
    var p = b.dataset.date.split("-");
    etat.date = new Date(+p[0], +p[1] - 1, +p[2]);
    etape(4);                      /* une date est choisie */
    /* Le RANG du jour essaye, pas la date : cinq jours cliques sans jamais
       choisir d'heure, c'est le signe qu'aucun creneau ne convenait — de la
       demande perdue faute de place, pas de l'hesitation. */
    geste("jour", String(++joursEssayes));
    etat.heure = null;
    effacerAlerte();
    rendreCalendrier();
    rendreHeures();
    majBouton();
    if (!el.bkBlocHeures.hidden) el.bkBlocHeures.scrollIntoView({ block: "nearest", behavior: "smooth" });
  });

  el.bkHeures.addEventListener("click", function (ev) {
    var b = ev.target.closest && ev.target.closest(".bk-heure");
    if (!b) return;
    etat.heure = +b.dataset.min;
    etape(5);                      /* une heure est choisie */
    geste("heure", cleForfait());
    /* 2026-09-16, demande d'Alex — QUELLE heure, et quel jour de semaine.
       `etat.heure` est en minutes depuis minuit (660 = 11h00). Trois gestes
       separes plutot qu'un seul detail « both_bronze-11h00 » : colles
       ensemble, ils ne s'additionneraient jamais entre eux, et on ne pourrait
       pas compter les 11h toutes formules confondues. C'est ce qui dit a
       quelles heures le monde VEUT venir — a comparer avec les heures qu'on
       ouvre reellement. */
    try {
      geste("creneau", Math.floor(etat.heure / 60) + "h" + ("0" + (etat.heure % 60)).slice(-2));
      if (etat.date) {
        geste("semaine", ["dimanche", "lundi", "mardi", "mercredi", "jeudi",
                          "vendredi", "samedi"][etat.date.getDay()]);
      }
    } catch (e) { /* la mesure ne casse jamais le choix d'une heure */ }
    signalerCreneau();
    rendreHeures();
    majBouton();
  });

  el.bkPrec.addEventListener("click", function () {
    moisAffiche = new Date(moisAffiche.getFullYear(), moisAffiche.getMonth() - 1, 1);
    rendreCalendrier();
  });
  el.bkSuiv.addEventListener("click", moisSuivant);

  /* On valide quand le client QUITTE le champ, jamais pendant qu'il tape :
     souligner en rouge une adresse a moitie ecrite est agressif pour rien.
     Une fois le rouge affiche, il disparait des que la saisie devient bonne. */
  CHAMPS.forEach(function (c) {
    var champ = el[c.entree];
    if (!champ) return;
    champ.addEventListener("blur", function () { validerChamp(c, true); });
    champ.addEventListener("input", function () {
      if (el[c.erreur] && !el[c.erreur].hidden) validerChamp(c, true);
    });
  });

  el.bkConfirmer.addEventListener("click", confirmerReservation);
  el.bkFermer.addEventListener("click", fermer);
  voile.addEventListener("click", function (ev) { if (ev.target === voile) fermer(); });

  /* Le focus reste dans le panneau tant qu'il est ouvert. */
  document.addEventListener("keydown", function (ev) {
    if (!voile.classList.contains("on")) return;
    if (ev.key === "Escape") { fermer(); return; }
    if (ev.key !== "Tab") return;
    var f = el.bkPanneau.querySelectorAll('button:not([disabled]), input, a[href], [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var premier = f[0], dernier = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === premier) { ev.preventDefault(); dernier.focus(); }
    else if (!ev.shiftKey && document.activeElement === dernier) { ev.preventDefault(); premier.focus(); }
  });

  /* ================= Inclusions ================= */

  /* Griser ce qui est deja compris dans un tier : le client ne peut pas payer
     deux fois la meme prestation. */
  (function majInclusions() {
    var inclus = {};
    ["argent", "or"].forEach(function (t) {
      ((cfg.inclusions && cfg.inclusions[t]) || []).forEach(function (c) {
        (inclus[c] = inclus[c] || []).push(TIERS[t]);
      });
    });
    Object.keys(inclus).forEach(function (c) {
      var btn = document.querySelector('.ajout-btn[data-ajout="' + c + '"]');
      if (!btn || btn.querySelector(".a-inclus")) return;
      var note = document.createElement("span");
      note.className = "a-inclus";
      note.textContent = "Déjà compris dans " + inclus[c].join(" et ");
      btn.appendChild(note);
    });
  })();

  /* Au chargement : si une reservation attend depuis une visite precedente,
     elle repart maintenant. C'est le filet, et il ne depend que du client. */
  viderLaFile();
  viderLaFileAlertes();   /* GESTE C : idem pour les alertes en attente */
})();
